import { GSMA_NSX_FEATURE_FLAG } from '../pages/Entitlements/modules/GsmaNsxSettings/constants';
import { useAuthStore } from '../store';
import { useBridgeKeeper } from './useBridgeKeeper';

interface GsmaNsxVisibilityParams {
  organisation?: { ues?: boolean } | null;
  hasNsxFlag?: boolean;
}

/**
 * Single source of truth for GSMA NSX visibility: the NSX settings replace
 * Network Details for UES organisations with the gsma_nsx BridgeKeeper flag
 * enabled; Network Details is the fallback in every other case.
 */
export const shouldShowGsmaNsx = ({
  organisation,
  hasNsxFlag,
}: GsmaNsxVisibilityParams) => {
  return Boolean(organisation?.ues) && Boolean(hasNsxFlag);
};

export const useShowGsmaNsx = () => {
  const {
    authValues: {
      organisationState: { organisation },
    },
  } = useAuthStore();
  const { showFeature: hasNsxFlag, isLoading } = useBridgeKeeper(
    GSMA_NSX_FEATURE_FLAG,
  );

  return {
    showGsmaNsx: shouldShowGsmaNsx({ organisation, hasNsxFlag }),
    hasNsxFlag: Boolean(hasNsxFlag),
    isLoading,
  };
};
